export const DefaultImageSize = 1024;
